export const BACK_TO_SCHOOL_CAMPAIGN_LAUNCH_DATE = new Date('2026-09-14T00:00:00+02:00')
